// this file is automatically generated by git-version script
export const version = {
  name: 'amg-provider-client',
  version: '1.65.0',
  commit: '7ea4808cd38ddfeea704bd28af9ddc66218c37f7',
  branch: 'platinum',
  dateGenerated: '2026-06-15T14:31:07.311Z',
};